/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GroupRuleMap,
    GroupRuleMapFromJSON,
    GroupRuleMapFromJSONTyped,
    GroupRuleMapToJSON,
} from './';

/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    readonly id: number;
    /**
     * The URN for the Group
     * @type {string}
     * @memberof Group
     */
    readonly urn: string;
    /**
     * Granular permission role
     * @type {string}
     * @memberof Group
     */
    readonly role?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    environment_key: string;
    /**
     * 
     * @type {GroupRuleMap}
     * @memberof Group
     */
    rules?: GroupRuleMap;
    /**
     * The ID of the Project this Group belongs to
     * @type {number}
     * @memberof Group
     */
    project_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof Group
     */
    readonly created_time: Date;
    /**
     * 
     * @type {Date}
     * @memberof Group
     */
    readonly updated_time: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    archived?: boolean;
    /**
     * Link to self
     * @type {string}
     * @memberof Group
     */
    readonly url?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    readonly update_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    readonly archive_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    readonly unarchive_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    readonly delete_url?: string;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof Group
     */
    readonly revision?: number;
}

export function GroupFromJSON(json: any): Group {
    return GroupFromJSONTyped(json, false);
}

export function GroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): Group {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'urn': json['urn'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'environment_key': json['environment_key'],
        'rules': !exists(json, 'rules') ? undefined : GroupRuleMapFromJSON(json['rules']),
        'project_id': !exists(json, 'project_id') ? undefined : json['project_id'],
        'created_time': (new Date(json['created_time'])),
        'updated_time': (new Date(json['updated_time'])),
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'update_url': !exists(json, 'update_url') ? undefined : json['update_url'],
        'archive_url': !exists(json, 'archive_url') ? undefined : json['archive_url'],
        'unarchive_url': !exists(json, 'unarchive_url') ? undefined : json['unarchive_url'],
        'delete_url': !exists(json, 'delete_url') ? undefined : json['delete_url'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
    };
}

export function GroupToJSON(value?: Group | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'environment_key': value.environment_key,
        'rules': GroupRuleMapToJSON(value.rules),
        'project_id': value.project_id,
        'archived': value.archived,
    };
}


